<template>
	<div class="basic_wrap">
		<bsHeader :title="$t('user.faq')" @backurl="$router.back()"></bsHeader>
		<div class="block_div wrap_box">
			<!-- <div class="item">
				<van-cell is-link v-for="(item,index) in data.list" :key="index"
					@click="$router.push('article/'+item.id)">
					<template #title>
						<div class="custom-title">{{item.title}}</div>
					</template>
				</van-cell>
			</div> -->

			<van-collapse v-model="activeNames" accordion>
				<van-collapse-item v-for="(item, index) in data.list" :key="index" :title="item.title" :name="index">
					<template #title>
						<div>{{ item.title }} <van-icon name="question-o" /></div>
					</template>
					<div @click="getImageSrcs(item.content)" class="content" v-html="item.content"></div>
				</van-collapse-item>
				<!-- <van-collapse-item title="标题1" name="1">内容</van-collapse-item>
				<van-collapse-item title="标题2" name="2">内容</van-collapse-item>
				<van-collapse-item title="标题3" name="3">内容</van-collapse-item> -->
			</van-collapse>
		</div>


		<!-- PDF 容器 -->
		<iframe v-if="showPdf" :src="extractedPDFLink" width="100%" height="600px"></iframe>
	</div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import {
	Cell,
	CellGroup,
	ImagePreview
} from 'vant';
Vue.use(Cell).use(CellGroup).use(ImagePreview);
export default {
	name: "",
	components: {
		bsHeader
	},
	data() {
		return {
			data: [],
			activeNames: "1",
			showPdf:false,
			extractedPDFLink:"",
		};
	},
	created() {
		if (window.plus) {
			plus.navigator.setStatusBarBackground('#FFFFFF');
			plus.navigator.setStatusBarStyle('dark');
		}
		this.$parent.footer('user', false);
	},
	mounted() {
		Fetch('/index/questions').then(r => {
			this.data = r.data;
		})
	},
	methods: {
		getImageSrcs(backendHTML) {
			if (backendHTML.includes('.pdf')) {
				const targetElement = event.target;

				// Check if the clicked element is an anchor (<a>) tag
				if (targetElement.tagName.toLowerCase() === 'a') {
					// Prevent the default behavior of the anchor tag (e.g., navigating to the href)
					event.preventDefault();

					// Extract the href attribute from the clicked anchor tag
					const pdfLink = targetElement.getAttribute('href');

					// Update the extractedPDFLink data property
					this.extractedPDFLink = pdfLink;

					// Perform any custom logic with the extracted PDF link
					this.$router.push({ name: 'pdf', params: { pdfLink } });
				}
			} else {
				// 使用 DOMParser 解析 HTML 字符串为 DOM 对象
				const parser = new DOMParser();
				const doc = parser.parseFromString(backendHTML, 'text/html');

				// 获取所有图片标签
				const imgTags = doc.querySelectorAll('img');

				// 提取每个图片标签的 src 属性
				const imageSrcs = Array.from(imgTags).map(imgTag => imgTag.src);
				if (imageSrcs.length > 0) {
					ImagePreview({
						images: imageSrcs,
						startPosition: 0,
					});
				}

				// console.log('Image Srcs:', imageSrcs);
			}

		},
		customMethod() {
			// Your custom logic with the extracted PDF link
			console.log('Image Srcs:', this.extractedPDFLink);
			this.showPdf=true;
		},
	},


};
</script>

<style lang="less" scoped>
.wrap_box {
	margin-top: 54px;

	.custom-title {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}

/deep/ .van-cell__title {
	width: 80%;
}

/deep/.van-cell {
	padding: 15px;
}

canvas {
	max-width: 100%;
	/* 保证 canvas 宽度不超过其容器宽度 */
}

hr {
	margin: 20px 0;
	border: 1px solid #ccc;
}
</style>
